
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form} from "reactstrap";
import ProjectForm from "./Form";
import UtilService from "../../../services/utilService";
import ProjectService from "../../../services/projectService";
import AdminService from "../../../services/adminService";
import _ from "lodash";

class ProjectEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            attendeesSelectKey: UtilService.uuidv4(),
            attendesForSelection: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
    }

    componentDidMount() {
        const {uniqueId} = this.props.match.params;
        ProjectService.fetch(uniqueId).then(response => {
            console.log(response.data);
            this.setState(response.data);
            this.setState({uniqueId: uniqueId});
            this.setState({selectedAttendees: response.data.sharedWith});
        });
        AdminService.list().then((response) => {
            console.log(response);
            this.setState({attendesForSelection: response.data, attendeesSelectKey: UtilService.uuidv4()});
        });
        console.log(this.state.attendesForSelection)
    }

    handleAttendeesChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedAttendees: []});
            this.setState({sharedWith: []});
        } else {
            this.setState({selectedAttendees: valueObj});
            const attendees = _.map(valueObj, "uniqueId")
            this.setState({sharedWith: attendees});
        }
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    handleSubmit(event) {
        event.preventDefault();
        ProjectService.update(this.state).then(response => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push(`/crm/project/show/${this.state.uniqueId}`);
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="Project"
                    heading="ClashMate"
                    newBtnUrl="/crm/project/create"
                    newBtnText="Create Project"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit Project</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ProjectForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={true}
                                    attendeesSelectkey={this.state.attendeesSelectKey}
                                    handleAttendeesChange={this.handleAttendeesChange}
                                    selectedAttendees={this.state.selectedAttendees}
                                    attendesForSelection={this.state.attendesForSelection}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ProjectEdit;
